import { useMemo } from 'react';
import { useQuery } from '@ts-core/lib/apollo';

import { getMediaItemsByCourseQuery } from '../graphql/queries';

export default function useCourseMediaItems({ courseId }) {
  const { data, loading } = useQuery(getMediaItemsByCourseQuery, {
    variables: { courseId },
    skip: !courseId,
    fetchPolicy: 'no-cache',
  });
  const mediaItems = useMemo(() => data?.mediaItems || [], [data]);

  return {
    mediaItems,
    loading,
  };
}
